module.exports = __webpack_public_path__ + "static/media/img-thumbnail-sushi-02.201d20c7.webp";